export const common = {
  loading: 'Memuatkan...',
  save: 'Simpan',
  cancel: 'Batal',
  close: 'Tutup',
  confirm: 'Sahkan',
  delete: 'Padam',
  edit: 'Edit',
  back: 'Kembali',
  next: 'Seterusnya',
  submit: 'Simpan',
  search: 'Cari',
  filter: 'Tapis',
  sort: 'Susun',
  more: 'Lagi',
  less: 'Kurang',
  yes: 'Ya',
  no: 'Tidak',
  ok: 'Selesai',
  error: 'Ralat',
  success: 'Berjaya',
  warning: 'Amaran',
  info: 'Maklumat',
  
  // Global loading states
  loadingData: 'Memuatkan data papan pemuka...',
  loadError: 'Gagal memuatkan data papan pemuka',
  retry: 'Cuba Lagi',
};

export const timeAgo = {
  today: 'hari ini',
  yesterday: 'semalam',
  daysAgo: '{count} hari lalu',
  weekAgo: '1 minggu lalu',
  weeksAgo: '{count} minggu lalu',
  monthAgo: '1 bulan lalu',
  monthsAgo: '{count} bulan lalu',
};
